require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.constructTwitchURL = constructTwitchURL;

var _utils = require("../../utils");

function constructTwitchURL(twitchId, channel, collection, baseUrl) {
  var srcBlocks = [baseUrl];

  if (twitchId !== undefined) {
    srcBlocks.push("&video=v".concat(twitchId));
  } else if (!(0, _utils.isEmptyString)(channel)) {
    srcBlocks.push("&channel=".concat(channel));
  } else if (!(0, _utils.isEmptyString)(collection)) {
    srcBlocks.push("&collection=".concat(collection));
  }

  return srcBlocks.join('');
}